import {BaseRouter} from "next/dist/shared/lib/router/router";
import {addClickSourceParam} from "./clickSourceUtil";
import {IClickSource} from "../interfaces/IClickSource";

export const getNavPath = (router: BaseRouter, path: string, clickSource?: IClickSource) => {
  const url = `/${router.query.country}/${router.query.lang}/${path==null || path=="/" ? "" : path}`;
  return clickSource ? addClickSourceParam(url, clickSource) : url;
}